// client/src/components/Countdown.js
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const getTimeParts = (endTime) => {
  const diff = new Date(endTime).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

// Ticks every second until endTime, then calls onEnd once.
const Countdown = ({ endTime, onEnd, sx }) => {
  const [parts, setParts] = useState(() => getTimeParts(endTime));

  useEffect(() => {
    setParts(getTimeParts(endTime));
    const interval = setInterval(() => {
      const next = getTimeParts(endTime);
      setParts(next);
      if (!next) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);

  useEffect(() => {
    if (parts === null && onEnd) onEnd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parts === null]);

  if (!parts) {
    return <Box component="span" sx={{ fontWeight: 600, color: 'text.disabled', ...sx }}>Auction Ended</Box>;
  }

  const { days, hours, minutes, seconds } = parts;
  const pad = (n) => String(n).padStart(2, '0');

  return (
    <Box component="span" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600, color: 'secondary.main', ...sx }}>
      {days > 0 && `${days}d `}
      {pad(hours)}:{pad(minutes)}:{pad(seconds)}
    </Box>
  );
};

export default Countdown;
